module.exports = __webpack_public_path__ + "static/media/prescriptions.7866d49c.svg";